module.exports = __webpack_public_path__ + "media/images/blobs/blob-green-light-d52f61eee422014b5baae36f93a0c62e.svg";